import { object } from '@iwentsourcing/core/typing/object.js';
import { array } from '@iwentsourcing/core/typing/array.js';
import { BrowseItem } from './browse-item.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { record } from '@iwentsourcing/core/typing/record.js';
import { StateValue } from '@iwentsourcing/core/storage/state-value.js';
import { nullable } from '@iwentsourcing/core/typing/nullable.js';

export const BrowseResult = object('BrowseResult', {
  items: array(BrowseItem),
  bookmark: nullable(record(string(), StateValue)),
});
